import { useQuery } from "@tanstack/react-query";

import { api } from "../api/rest";
import type { PairRoleSummary, PairSignal } from "../api/types";

/** Такт опроса теневого журнала пары. Тот же, что у соседей. */
const PAIR_REFETCH_MS = 15_000;

/**
 * Окно сводки по умолчанию — НЕДЕЛЯ.
 *
 * Пара дешевле доллара — редкое событие, и суточная выборка отвечала бы «пар не
 * было» в большинстве суток, что на экране неотличимо от сломанной подсистемы.
 */
export const PAIR_DEFAULT_HOURS = 24 * 7;

/** Сводка пары по ролям. */
export function usePairSummary(hours: number, windowLen = 0) {
  return useQuery<{ hours: number; roles: PairRoleSummary[] }>({
    queryKey: ["pair-summary", hours, windowLen],
    queryFn: () => api.pairSummary(hours, windowLen),
    refetchInterval: PAIR_REFETCH_MS,
    retry: 1,
  });
}

/** Лента теневых пар, свежие сверху. */
export function usePairSignals(hours: number, limit = 60, windowLen = 0) {
  return useQuery<{ signals: PairSignal[] }>({
    queryKey: ["pair-signals", hours, limit, windowLen],
    queryFn: () => api.pairSignals(hours, undefined, limit, windowLen),
    refetchInterval: PAIR_REFETCH_MS,
    retry: 1,
  });
}
